import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useMutation, useQueryClient } from 'react-query';
import { firestore } from 'fb';
import { toast } from 'react-toastify';
import { UserContext } from "components/UserContext";
import { useContext } from "react";
import { useProfileMutation } from "routes/ProfilePage";

type OpinionMutationData = { values: any };

export const useOpinionMutation = () => {
  const { user } = useContext(UserContext);
  const client = useQueryClient();
  const { mutate } = useProfileMutation();
  return useMutation<void, unknown, OpinionMutationData>(async ({ values }) => {
    if (!user) {
      throw new Error('Cannot post opinion without being logged in');
    }

    await addDoc(collection(firestore, 'opinions'), {
      ...values,
      symbol: values.symbol || null,
      createdAt: serverTimestamp(),
      likesCount: 0,
      reportsCount: 0,
      uid: user.uid,
      isConfirmed: false,
    });

    await mutate({ user, values: { canReadReason: '심사를 시작했습니다. 심사가 완료되면 프로필 페이지에서 알려드립니다.' } });
  }, {
    onSuccess: async () => {
      await client.invalidateQueries(['opinions']);
      toast.success('성공적으로 등록됐습니다 :)');
    },
    onError: (error) => {
      toast.error(`에러가 발생했습니다. ${error}`);
    },
  });
};
